import type { ComponentProps } from 'react'

import { cn } from '@/customer/lib/utils'

/** Supporting copy displayed beneath a page headline. */
export function PageDescription({
  className,
  margin = false,
  ...props
}: ComponentProps<'p'> & { margin?: boolean }) {
  return (
    <p
      className={cn(
        'text-body-md md:text-body-lg text-muted-foreground',
        margin && 'mb-6 md:mb-8',
        className
      )}
      {...props}
    />
  )
}
